import { NamePath } from 'antd/lib/form/interface';
import { Form, Select } from 'antd';
import { useListExpertCollections } from '../services/hooks';

export const ListExpertCollectionSelect = ({
  name,
  label,
  placeholder,
}: {
  name: NamePath;
  label: string;
  placeholder: string;
}) => {
  const { data, isFetching } = useListExpertCollections();

  return (
    <Form.Item label={label} name={name}>
      <Select
        className="min-w-[200px]"
        mode="multiple"
        placeholder={placeholder}
        allowClear
        loading={isFetching}
        filterOption={(input, option) =>
          option?.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        options={data?.expertCollections?.map((collection) => ({
          value: collection.idCollection,
          label: collection.name,
        }))}
        labelInValue
      />
    </Form.Item>
  );
};
